var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.4043V19.4043H2V17.4043C2 17.4043 2 13.4043 9 13.4043C16 13.4043 16 17.4043 16 17.4043ZM12.5 7.90435C12.5 7.21211 12.2947 6.53543 11.9101 5.95985C11.5256 5.38428 10.9789 4.93568 10.3394 4.67077C9.69985 4.40586 8.99612 4.33655 8.31718 4.4716C7.63825 4.60665 7.01461 4.93999 6.52513 5.42948C6.03564 5.91896 5.7023 6.5426 5.56725 7.22153C5.4322 7.90047 5.50152 8.6042 5.76642 9.24374C6.03133 9.88328 6.47993 10.4299 7.0555 10.8145C7.63108 11.1991 8.30777 11.4043 9 11.4043C9.92826 11.4043 10.8185 11.0356 11.4749 10.3792C12.1313 9.72285 12.5 8.83261 12.5 7.90435ZM15.94 13.4043C16.5547 13.8801 17.0578 14.4848 17.4137 15.1759C17.7696 15.8669 17.9697 16.6276 18 17.4043V19.4043H22V17.4043C22 17.4043 22 13.7743 15.94 13.4043ZM15 4.40435C14.3117 4.40052 13.6385 4.60631 13.07 4.99435C13.6774 5.84309 14.0041 6.86064 14.0041 7.90435C14.0041 8.94806 13.6774 9.96561 13.07 10.8143C13.6385 11.2024 14.3117 11.4082 15 11.4043C15.9283 11.4043 16.8185 11.0356 17.4749 10.3792C18.1313 9.72285 18.5 8.83261 18.5 7.90435C18.5 6.97609 18.1313 6.08585 17.4749 5.42948C16.8185 4.7731 15.9283 4.40435 15 4.40435Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.4de3f572a9cd348602b6458521b38152.svg";
export { ForwardRef as ReactComponent };